<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">{{ title }}</div>
    </div>
    <div class="card-body">
      <form [formGroup]="rejectionForm">
        <div class="form-group">
          <label class="form-check" *ngFor="let reason of rejectionReasons">
            <input class="form-check-input" 
                   type="checkbox"
                   [value]="reason"
                   [checked]="rejectionReasonArray.value.includes(reason)"
                   (change)="onCheckboxChange($event)">
            <span class="form-check-label">{{reason}}</span>
          </label>
        </div>
        <div class="form-group">
          <label class="form-label">Komentar</label>
          <textarea class="form-control" rows="3" formControlName="rejectionComment"></textarea>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="rejectionForm.invalid || (offer.rejectionReasons && offer.rejectionComment)">Potvrdi</button>
    </div>
  </div>
</div>
